import multiApiClient from "./base";

export const sellerlogicApi = {
  getCredentials: () => {
    return multiApiClient.get("/sellerlogic/credentials/");
  },

  createCredential: (data) => {
    return multiApiClient.post("/sellerlogic/credentials/", data);
  },

  deleteCredential: (credentialId) => {
    return multiApiClient.delete(`/sellerlogic/credentials/${credentialId}`);
  },

  updateCredential: (credentialId, data) => {
    return multiApiClient.put(`/sellerlogic/credentials/${credentialId}`, data);
  },

  toggleActiveCredential: (credentialId) => {
    return multiApiClient.post(
      `/sellerlogic/credentials/${credentialId}/toggle-active`,
    );
  },

  testCredential: (credentialId) => {
    return multiApiClient.post(`/sellerlogic/credentials/${credentialId}/test`);
  },

  testCredentialKey: (data) => {
    return multiApiClient.post(`/sellerlogic/credentials/test-key`, data);
  },
};
